import { EAuthRole } from '../types';
import { useAuth } from './useAuth';

/**
 * Pure check: whether the currently authenticated user's role is permitted by
 * `allowedRoles`. Has no side effects.
 *
 * Returns `true` when there is no user yet or when `allowedRoles` is omitted
 * (the app is treated as open to any authenticated user).
 */
export const useRoleGuard = (allowedRoles?: EAuthRole[]) => {
    const { user } = useAuth();

    return !allowedRoles || !user || allowedRoles.includes(user.role);
};
